



































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ConfirmModal extends Vue {
  @Prop({ default: "確認" }) pTitle!: string;
  @Prop({ default: "同意しますか?" }) pMessage!: string;
  @Prop({ default: "はい" }) pYesMessage!: string;
  @Prop({ default: "いいえ" }) pNoMessage!: string;
  @Prop({ default: false }) pReverse!: boolean;
  @Prop({ default: true }) pPersistentMode!: boolean;

  dialog = false;

  open() {
    this.dialog = true;
  }

  cancel() {
    this.dialog = false;
  }

  confirm() {
    this.dialog = false;
    this.$emit("confirm");
  }
}
